export const FOOTER_CONSTANTS = {
  COMPANY_DESCRIPTION: "Leader nei servizi di disinfestazione e derattizzazione a Roma. Soluzioni professionali e sicure per privati e aziende.",
  COPYRIGHT: "Tutti i diritti riservati.",
  
  QUICK_LINKS: {
    TITLE: "Link Utili",
    LINKS: [
      { text: "Contatti", href: "#contatti" },
      { text: "Lavora con Noi", href: "#careers" },
      { text: "Privacy Policy", href: "/privacy" },
      { text: "Termini di Servizio", href: "/terms" },
    ],
  },

  HOME_SECTIONS: {
    TITLE: "Home",
    SECTIONS: [
      { name: "Servizi Più Richiesti", sectionId: "servizi", description: "I nostri servizi principali" },
      { name: "Chi Siamo", sectionId: "chi-siamo", description: "La nostra storia e missione" },
      { name: "I Nostri Valori", sectionId: "valori", description: "Professionalità e qualità" },
      { name: "Ci Hanno Scelto", sectionId: "partner", description: "Collaborazioni di fiducia" },
      { name: "Contattaci per un Preventivo", sectionId: "preventivo", description: "Richiedi subito un preventivo gratuito" },
    ],
  },

  SERVICES: {
    TITLE: "Servizi",
    LIST: [
      { name: "Disinfestazione", page: "disinfestazione" },
      { name: "Derattizzazione", page: "derattizzazione" },
      { name: "Sanificazione Ambientale", page: "sanificazione" },
      { name: "Diserbo", page: "diserbo" },
      { name: "Allontanamento Volatili", page: "allontanamento-volatili" },
      { name: "Pest Management Integrato", page: "pest-management" },
    ],
  },

  CONTACT: {
    TITLE: "Contatti",
  },

  EMERGENCY: {
    LABEL: "Emergenze 24/7",
    HOURS: "Disponibile 24 ore su 24, 7 giorni su 7",
  },

  AREAS: {
    TITLE: "Zone Servite",
    ZONES: [
      "Roma Centro",
      "Roma Nord",
      "Roma Sud", 
      "Roma Est",
      "Roma Ovest",
      "Comuni Limitrofi",
      "Provincia di Roma",
    ],
  },
} as const;